import { render, staticRenderFns } from "./trustpilot-stars.vue?vue&type=template&id=fdbeb216&"
import script from "./trustpilot-stars.vue?vue&type=script&lang=js&"
export * from "./trustpilot-stars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports